import axios from '@/axios';
// Define page types as constants
export const TERMS_PAGE = 'terms';
export const PRIVACY_PAGE = 'privacy';
export const COOKIE_PAGE = 'cookie';

export default {
  namespaced: true,
  state: {
    pages: [],
    error: null,
  },
  getters: {
    getTermsPage: (state) => state.pages.find((page) => page.is_terms === 1),
    getPrivacyPage: (state) =>
      state.pages.find((page) => page.is_privacy === 1),
    getCookiePage: (state) =>
      state.pages.find((page) => page.is_cookie === 1),
    // Get page URL by type
    getPageUrl: (state) => (type) => {
      let page = null;

      switch (type) {
        case TERMS_PAGE:
          page = state.pages.find((p) => p.is_terms === 1);
          break;
        case PRIVACY_PAGE:
          page = state.pages.find((p) => p.is_privacy === 1);
          break;
        case COOKIE_PAGE:
          page = state.pages.find((p) => p.is_cookie === 1);
          break;
        default:
          return null;
      }

      return page && page.slug ? `/${page.slug}` : null;
    },
    // Simplified getPageByType that doesn't depend on other getters
    getPageByType: (state) => (type) => {
      switch (type) {
        case TERMS_PAGE:
          return state.pages.find((page) => page.is_terms === 1);
        case PRIVACY_PAGE:
          return state.pages.find((page) => page.is_privacy === 1);
        case COOKIE_PAGE:
          return state.pages.find((page) => page.is_cookie === 1);
        default:
          return null;
      }
    },
  },
  mutations: {
    setPages(state, pages) {
      state.pages = pages;
    },
    setError(state, error) {
      state.error = error;
    },
  },
  actions: {
    async fetchPages({ commit }, langId) {
      try {
        const { data } = await axios.get('static-pages', { params: { lang_id: langId } });
        if (data.status === 'OK') {
          commit('setPages', data.payload);
        }
      } catch (error) {
        commit('setError', error.message);
      }
    },

    async fetchPageContent({ commit }, { id, langId }) {
      try {
        const { data } = await axios.get(`static-pages/${id}`, { params: { lang_id: langId } });

        if (data.status === 'OK') {
          return data.payload;
        }
      } catch (error) {
        // If page not found with current language, try English
        if (error.response?.status === 404 && langId !== 1) {
          return this.dispatch('staticPages/fetchPageContent', {
            id,
            langId: 1,
          });
        }
        commit('setError', error.message);
        throw error;
      }
    },

    navigateToPage({ state }, { type, router }) {
      let page = null;

      if (type === TERMS_PAGE) {
        page = state.pages.find((p) => p.is_terms === 1);
      } else if (type === PRIVACY_PAGE) {
        page = state.pages.find((p) => p.is_privacy === 1);
      } else if (type === COOKIE_PAGE) {
        page = state.pages.find((p) => p.is_cookie === 1);
      }

      if (page?.slug) {
        router.push({ name: 'TextPage', params: { slug: page.slug } });
        return page.id;
      }
      return null;
    },
  },
};
